import { Box, Button, TableCell, TableRow, Typography } from "@mui/material";
import React, { useState } from "react";
import { ImageContainer } from "../../../../shared/components/ImageContainer";
import { EditIcon, TrashIcon } from "../../../../assets/icons/icons";
import { useNavigate } from "react-router-dom";

interface tableRowProps {
  row: any;
}

const Row: React.FC<tableRowProps> = ({ row }) => {
  const navigate = useNavigate();
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);

  const handleEdit = (row: any) => {};

  const handleDelete = async () => {};
  return (
    <TableRow
      onClick={() => {}}
      sx={{
        cursor: "pointer",
        ":hover": {
          bgcolor: "rgba(255, 255, 255, 0.06) !important",
        },
      }}
      hover
      tabIndex={-1}
      key={row?.id}
    >
      {/* Question  */}
      <TableCell
        sx={{
          width: "300px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300", wordBreak: "break-word" }} variant="body2">
          {row?.question || "-"}
        </Typography>
      </TableCell>

      {/* Answer  */}
      <TableCell
        sx={{
          //  width: "400px",
          flex: 1,
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography
          sx={{ color: "white", fontWeight: "300", wordBreak: "break-word" }}
          variant="body2"
        >
          {row?.answer || "-"}
        </Typography>
      </TableCell>

      {/* Action buttons  */}
      <TableCell
        sx={{
          maxWidth: "80px",
          minWidth: "80px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <Button
            onClick={() => {
              handleEdit(row);
            }}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
              ":hover": {
                bgcolor: "none !important",
              },
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title={"edit"}
            >
              {EditIcon}
            </ImageContainer>
          </Button>

          <Button
            onClick={() => {}}
            sx={{
              minWidth: "0px",
              minHeight: "0px",
              lineHeight: "0px",
            }}
          >
            <ImageContainer
              style={{ width: "24px", height: "24px" }}
              title="trash"
            >
              {TrashIcon}
            </ImageContainer>
          </Button>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default Row;
